// HTML 헤더 부분 (스타일 포함)
export const htmlHeader = `<html>
<head>
  <style>
    @page {
      size: 1000px 636px;
      margin: 0;
      padding: 30px;
    }
    @media print {
      .detail-table-wrap {
        page-break-inside: avoid;
        break-inside: avoid;
        min-height:575px;
        table-layout: fixed !important;
      }
      .caption {
        page-break-inside: avoid;
        break-inside: avoid;
      }
      .medical-bill-table {
        
          table-layout: fixed !important;
      }
      .medical-bill-table thead {
        display: table-header-group;
      }
    }


    body {
      font-family: 'Pretendard Variable', sans-serif !important;
      margin: 0;
      padding: 0;
    }
    .detail-bills {
      margin-bottom: 40px;
      break-after: page;
      display: block;
      width: 100%;
      overflow: visible;
      position:relative !important;
    }
    .detail-table-wrap {
      position:relative !important;
      width: 100%;
      height:100vh !important;
     
      display: block;
      background: #ffffff;
      box-sizing: border-box;
      min-width: 900px;
      transform-origin: top left;
      box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .detail-table-wrap p {
      font-weight: 400;
      font-style: Regular;
      font-size: 10px;
      line-height: 100%;
      letter-spacing: 0%;
    }
    .caption {
      text-align: center;
      padding: 10px;
      border-radius: 5px;
      page-break-inside: avoid;
      break-inside: avoid;
      page-break-after: auto;
      break-after: auto;
    }
    .caption .center-text {
      font-size: 16px;
      font-weight: bold;
      font-weight: 700;
      font-style: Bold;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;
      display: flex;
      text-align: center;
      justify-content: center;
      padding: 5px;
      border-radius: 3px;
    }
    .caption .right-box {
      position: absolute;
      right: 0;
      transform: translateY(-50%);
      text-align: left;
      padding: 5px;
      border-radius: 3px;
    }
    .caption .right-box .txt {
      height: 15px;
    }
    .caption .right-box .txt span {
      font-size: 10px;
      color: #9198a3;
      display: inline-block;
    }
    .caption .right-box .txt span:first-child {
      width: 40px;
    }
    .sub-desc {
      font-size: 10px;
      text-align: left;
      padding: 5px;
      border-radius: 3px;
    }
    .medical-bill-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 10px;
      color: #000000;
      table-layout: auto;
      font-size: 0.75rem;
      page-break-inside: auto;
      break-inside: auto;
    }
   
    .medical-bill-table + .medical-bill-table th{border-top:0;}
    .medical-bill-table th,
    .medical-bill-table td {
      border-bottom: 1px solid #9198a3;
      border-right: 1px solid #000000;
    }
    .medical-bill-table.top thead tr td {
      text-align: center;
      border: 1px solid #9198a3;
      border-right: 1px solid #000000;
      border-top: 1px solid #000000;
    }
    .medical-bill-table.top thead tr td:last-child {
      border-right: none;
    }
    .medical-bill-table.top thead tr td:first-child {
      border-left: none;
    }
    .medical-bill-table.top tbody tr td {
      border: 1px solid #9198a3;
      border-right: 1px solid #000000;
      border-bottom: 1px solid #000000;
    }
    .medical-bill-table.top tbody tr td:nth-child(5) {
      text-align: center !important;
    }
    .medical-bill-table.top tbody tr td:last-child {
      border-right: none;
    }
    .medical-bill-table.top tbody tr td:first-child {
      border-left: none;
    }
    .medical-bill-table tr > th:first-child,
    .medical-bill-table tr > td:first-child {
      border-left: none;
    }

    .medical-bill-table tr > th:last-child,
    .medical-bill-table tr > td:last-child {
      border-right: none;
    }
    .medical-bill-table thead .fixed-62 {
      width: 62px;
    }
    .medical-bill-table thead .fixed-200 {
      width: 200px;
    }
    .medical-bill-table thead th {
      border-bottom: 1px solid #000 !important;
    }
    .medical-bill-table tbody th,.medical-bill-table tbody tr:first-child td {
      border-top: 1px solid #000 !important;
    }
    .medical-bill-table.top tbody tr:first-child td {
      border-top: 1px solid #9198a3 !important;
    }


    th.fixed-120, td.fixed-120 { width: 120px !important; }
    th.fixed-62, td.fixed-62 { width: 62px; }
    th.fixed-25, td.fixed-25 { width: 25px; }
    th.min-25 { min-width: 25px; }

    .medical-bill-table thead .fixed-25 {
      width: 25px;
    }
    .medical-bill-table thead th,
    .medical-bill-table thead td {
      font-size: 10px;
      font-weight: normal;
      border: 1px solid #000000;
    }
    .medical-bill-table thead {
      page-break-inside: avoid;
      break-inside: avoid;
      display: table-header-group;
    }
    .medical-bill-table tbody .none-border td,
    .medical-bill-table tbody .none-border tr {
      border: none !important;
      font-weight: 600;
    }
    .medical-bill-table tbody .none-boder {
      border: none !important;
    }
    .medical-bill-table tbody .border-right {
      border-right: 1px solid #000000 !important;
    }
    .medical-bill-table tbody tr td {
      font-size: 10px;
     
    }
    .medical-bill-table tbody .border-top-black {
      border-top: 2px solid #000000;
    }
    .medical-bill-table tbody .border-bottom-black {
      border-bottom: 2px solid #000000;
    }
   
    .medical-bill-table tbody tr td:nth-child(4) {
      width:200px !important;
      min-width:200px;
      max-width:200px;
    }
    .medical-bill-table tbody tr td:nth-child(6){
        width:35px;
        min-width: 35px;
    }
      .medical-bill-table tbody tr td:nth-child(7) {
      width:25px !important;
      min-width:25px;
      max-width:25px;
    }


    .medical-bill-table tbody tr td:nth-child(5),
    .medical-bill-table tbody tr td:nth-child(6),
    .medical-bill-table tbody tr td:nth-child(7),
    .medical-bill-table tbody tr td:nth-child(8),
    .medical-bill-table tbody tr td:nth-child(9),
    .medical-bill-table tbody tr td:nth-child(10),
    .medical-bill-table tbody tr td:nth-child(11),
    .medical-bill-table tbody tr td:nth-child(12) {
      text-align: right !important;
    }
    .medical-bill-table tbody tr td:nth-child(1),
    .medical-bill-table tbody tr td:nth-child(2),
    .medical-bill-table tbody tr td:nth-child(3),
    .medical-bill-table tbody tr td:nth-child(4) {
      text-align: left;
    }
    .medical-bill-table .text-center tr td {
      text-align: center !important;
    }
    .sub-txt {
      font-family: Pretendard Variable;
      font-weight: 400;
      font-style: Regular;
      font-size: 10px;
      line-height: 14px;
      letter-spacing: 0%;
      text-align: center;
      color: #000000;
      padding: 10px;
      border-radius: 5px;
    }
    .sub-txt span:last-child {
      margin-top:6px;
      display:inline-block;
    }
    .medical-info-footer {
      width: 100%;
      border-collapse: collapse;
      font-size: 10px;
      color: #000000;
      table-layout: fixed;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .detail-table-wrap .medical-info-footer .hsp-name,
    .detail-table-wrap .medical-info-footer .ceo-name > span {
      color: #000;
      font-family: 'Pretendard Variable';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .medical-info-footer .footer-list {
      line-height: normal;
      text-align: left;
    }
    .medical-info-footer .footer-list > div {
      width: 100%;
    }
    .medical-info-footer .footer-list > div > div {
      text-align: left !important;
      display: table;
      width:100%;
    }
    .medical-info-footer .footer-list > div > div span {
      display: table-cell;
    }
    .medical-info-footer .footer-list > div > div span:first-child {
      padding-right: 3px;
      width:10px;
    }
    .medical-info-footer tbody tr th,
    .medical-info-footer tbody tr td {
      font-size: 10px;
      font-weight: 400;
      text-align: center;
      border: 1px solid #000000;
      padding: 0 2px;
      color: #000000;
    }
    .medical-info-footer tbody ol li {
      text-align: left;
    }
    .medical-info-footer tbody tr td:last-child {
      border-right: none;
    }
    .medical-info-footer tbody tr td:first-child {
      border-left: none;
    }
    .medical-info-footer tbody ol {
      list-style-type: decimal;
      padding-left: 10px;
    }
    .medical-info-footer tbody ol li {
      font-family: Pretendard Variable;
      font-weight: 400;
      font-style: Regular;
      font-size: 10px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: left;
      list-style-type: decimal;
    }
    .detail-table-wrap .sign-wrap {
      position: relative;
    }
    .detail-table-wrap .sign-wrap img {
      position: absolute;
      bottom: -15px;
      right: 0;
      width: 40px;
      height: 40px;
    }/*# sourceMappingURL=detail.css.map */
    .detail-table-wrap .medical-bill-table.top {
    table-layout:fixed !important;
    }
    .detail-table-wrap .medical-bill-table.top thead tr td
    {position: relative;
      border-right: 1px solid black !important;
      border:1px solid black;
      border-bottom:1px solid #9198a3 !important;
    }
  .detail-table-wrap .medical-bill-table.top thead tr td::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: -2px;
    left: -1px;
    width: 1px;
    background: black;
    z-index: 100; /* 가로선보다 위 */
  }
  .detail-table-wrap .medical-bill-table.top thead tr td:first-child:before {
    display:none;
  }
  .detail-table-wrap .medical-bill-table.top thead tr td:first-child {
    border-left:none !important;
  }
  .detail-table-wrap .medical-bill-table.top thead tr td:last-child {
    border-right:none !important;
  }
  .detail-table-wrap .medical-bill-table.top tbody tr td {
    border-right: 1px solid black !important;
    border:1px solid black !important;
    border-bottom:1px solid black !important;
  } 
  .detail-table-wrap .medical-bill-table.top tbody tr td:first-child {
    border-left:none !important;
  }
  .detail-table-wrap .medical-bill-table.top tbody tr td:last-child {
    border-right:none !important;
  }
  .hsp-logo-wrap {
    display: flex;
    position: absolute;
    bottom: 0;
    right: 0;
    right: 0;
  }
  .hsp-logo-wrap img {
    width:100px;
  }
    .detail-table-wrap .medical-bill-table tbody tr.divider-row {
     background: #eceef3;
    }
  .detail-table-wrap .medical-bill-table tbody tr.divider-row td {
    text-align: left;
    background: #eceef3;
    border-right-color: #eceef3 !important;
    text-align: left !important;
  }
  .detail-table-wrap .medical-bill-table tbody tr.total-row-first td {
    border-top: 2px solid #000;
  }
  .detail-table-wrap .medical-bill-table tbody tr.total-row-last td {
    border-bottom: 2px solid #000;
  }
  </style>
</head>
<body>`;

// HTML 푸터 부분
export const htmlFooter = `</body>
</html>`;

// 페이지별 콘텐츠 템플릿 (body 내용만)
export const pageContentTemplate = `<div class="detail-table-wrap">
  <div class="caption">
      <div class="center-text">진료비 세부산정내역(<span name="detail_statement_type"></span>)</div>
      <div class="right-box">
          <div class="txt" style="font-weight: normal;">
            <span>출력일자: </span>
            <span name="print_dt"></span>
          </div>
          <div class="txt" style="font-weight: normal;">
            <span>Page: </span>
            <span name="page_info"></span>
      </div>
    </div>
  </div> 
  <div class="sub-desc" style="text-align:left;">요양기관기호 : <span name="rcorg_no"></span></div>
  <table class="medical-bill-table top">
    <thead>
      <tr>
        <td>환자등록번호</td>
        <td>환자성명</td>
        <td>진료기간 :</td>
        <td>병실</td>
        <td>환자구분</td>
        <td>비고</td>
      </tr>
    </thead>
    <tbody class="text-center">
      <tr>
        <td name="pt_no"></td>
        <td name="pt_nm"></td>
        <td name="med_period"></td>
        <td name="ward_room"></td>
        <td name="pt_gb"></td>
        <td name="remark"></td>
      </tr>
    </tbody>
  </table>

  <table class="medical-bill-table">
  <colgroup>
        <col rowspan="3" style="width:auto;" />
        <col rowspan="3" style="width:62px;"/>
        <col rowspan="3" style="width:auto;"/>
        <col rowspan="3" style="white-space: nowrap; width:200px; min-width:200px; max-width:200px; overflow: hidden;"/>
        <col rowspan="3" style="width:auto;"/>
       <col  rowspan="3" style="width: 35px; min-width: 35px;" />
        <col rowspan="3" style="width:25px;"/>
        <col rowspan="3" style="width:auto;"/>
        <col colspan="3" style="width:auto;"/>
        <col rowspan="3" style="width:auto;"/>
  </colgroup>
    <thead>
      <tr>
        <th rowspan="3" >항목</th>
        <th rowspan="3">일자</th>
        <th rowspan="3">코드</th>
        <th rowspan="3" class="fixed-200" >명칭</th>
        <th rowspan="3">금액</th>
        <th rowspan="3">횟수</th>
        <th rowspan="3" >일수</th>
        <th rowspan="3">총액</th>
        <th colspan="3">급여</th>
        <th rowspan="3">비급여</th>
      </tr>
      
      <tr>
        <th colspan="2">일부본인부담</th>
        <th colspan="1" rowspan="2">전액본인부담</th>
      </tr>
      <tr>
        <th>본인부담금</th>
        <th>공단부담금</th>
      </tr>
    </thead>
    <tbody name="table_body">
      <!-- 테이블 내용이 여기에 들어갑니다 -->
    </tbody>
  </table>
  <div name="footer_content">
    <!-- 푸터 내용이 여기에 들어갑니다 -->
  </div>
</div>`;

// 공통 footer 콘텐츠 생성 함수
const createFooterContent = (isSinglePage = false) => {
  const wrapperClass = isSinglePage ? 'detail-table-wrap' : '';
  const wrapperStart = isSinglePage ? `<div class="${wrapperClass}"><div class="caption">` : '';
  const wrapperEnd = isSinglePage ? '</div></div>' : '';

  const rightBox = isSinglePage
    ? `
  <div class="right-box">
    <div class="txt" style="font-weight: normal;">
      <span>출력일자: </span>
      <span name="print_dt"></span>
    </div>
    <div class="txt" style="font-weight: normal;">
      <span>Page: </span>
      <span name="page_info"></span>
    </div>
  </div>
  `
    : ``;

  return `${wrapperStart}
   ${rightBox}
  <div class="sub-txt">
    신청인 <span name="pt_nm"></span>(환자와의 관계: 본인)의 요청에 따라<br/>진료비 계산서 영수증 세부산정내역을 발급합니다.
    <br />
    <span name="apply_dt"></span>
  </div>
  <table class="medical-info-footer">
    <colgroup>
      <col style="width:120px;"/>
      <col style="width:380px;"/>
      <col style="width:120px;"/>
      <col style="width:auto;"/>
    </colgroup>
    <tbody>
      <tr>
        <td class="fixed-120">요양기관 명칭</td>
        <td class="hsp-name fixed-380">계명대학교 동산병원</td>
        <td class="fixed-120">대표자</td>
        <td class="ceo-name"><span name="rpst_nm"></span>      <div class="sign-wrap">
          <img src="https://karechat-storage.kakaohealthcare.com/dsmc/stamp.png" alt="대표자 도장이미지"/>
        </div></td>
      </tr>
      <tr>
        <td colspan='4'>일반사항 안내</td>
      </tr>
      <tr>
        <td colspan='4' class="footer-list">
          <div>
            <div>
              <span>1.</span>
              <span>
                진료비 계산서 영수증의 세부내역서는 환자의 구체적인 처방 내역 등이 확인되므로 원칙적으로 환자 본인
                외에 발급을 금합니다. 다만, 본 세부내역서 발급에 대해 별도로 환자 본인으로부터 위임을 받은 것이 확인된
                자 또는 법정대리인에겐 발급이 가능합니다.
              </span>
            </div>
            <div>
              <span>2.</span>
              <span>
              비고란은 세부산정내역을 발부하는 영수증번호 등 요양기관이 필요한 경우 추가 기재하는 공간으로 활용할 수
              있습니다.
              </span>
            </div>
            <div>
              <span>3.</span>
              <span>
              동 서식에 명시된 항목은 [국민건강보험 요양급여의 기준에 관한 규칙] 제7조제3항에 따라 필수 기재되어야
              합니다.
              </span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>    
  <div class="hsp-logo-wrap">
    <img src="https://karechat-storage.kakaohealthcare.com/dsmc/hsp-logo-detail-statement.png" alt="병원 로고"/>
  </div>
${wrapperEnd}`;
};

// 푸터 콘텐츠 템플릿 (기존 footerContentTemplate 대체)
export const footerContentTemplate = createFooterContent(false);

// 단일 페이지 푸터 콘텐츠 템플릿 (기존 singlePagefooterContentTemplate 대체)
export const singlePagefooterContentTemplate = createFooterContent(true);

// 기존 호환성을 위한 전체 템플릿
export const detailTemplate = htmlHeader + pageContentTemplate + htmlFooter;
